import { computed, type MaybeRefOrGetter, toValue } from "vue";
import { useOperationalTranslationsQuery } from "@/features/experience-curation/queries/useOperationalTranslationsQuery";

/**
 * Encapsulates the query + find-by-id logic for a single operational translation.
 * Reusable across field stores and components that need access to a specific translation.
 */
export function useOperationalTranslation(operationalId: MaybeRefOrGetter<string>, languageCode?: string) {
  const query = useOperationalTranslationsQuery(languageCode);

  const translation = computed(() => query.data.value?.find((t) => t.operational_id === toValue(operationalId)));

  return { query, translation };
}
